export const sanitizeId = (id: string) => id.replaceAll("/", "x--x");
export const desanitizeId = (id: string) => id.replaceAll("x--x", "/");
